function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as productSetting from '@/api/productSetting.js';
import { categoryApi } from '@/api/store';
export default {
  components: {},
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      listPram: {
        keywords: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      constants: this.$constants,
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      selectIds: [],
      merCateList: [],
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false
      },
      pageSelectIds: {}
    };
  },
  watch: {
    value: {
      handler: function handler(value) {
        this.selectIds = value || [];
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    this.getCategorySelect();
  },
  methods: {
    openInit: function openInit() {
      this.visible = true;
      this.handlerGetListData(this.listPram);
    },
    handerSubmit: function handerSubmit() {
      this.visible = false;
      var selectMap = {};
      var selectLs = [];
      // 去重
      this.selectIds.forEach(function (productItem) {
        var _ref = productItem || {},
          id = _ref.id,
          skuCode = _ref.skuCode,
          skuName = _ref.skuName,
          price = _ref.price,
          productId = _ref.productId,
          otPrice = _ref.otPrice,
          attrImage = _ref.attrImage;
        var obj = {
          id: id,
          skuCode: skuCode,
          skuName: skuName,
          price: price,
          productId: productId,
          otPrice: otPrice,
          image: attrImage
        };
        selectMap[id] = obj;
      });
      Object.keys(selectMap).forEach(function (key) {
        selectLs.push(selectMap[key]);
      });
      this.$emit('input', selectLs);
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    // 列表分页查询
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      productSetting.skuListArticle(_objectSpread({}, pram)).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
        setTimeout(function () {
          if (_this.value && _this.value.length) {
            var _data$list = data.list,
              list = _data$list === void 0 ? [] : _data$list;
            _this.value.forEach(function (row) {
              var idx = list.findIndex(function (item) {
                return item.id == row.id;
              });
              _this.$refs.tableListRef.toggleRowSelection(data.list[idx]);
            });
            _this.selectIds = _this.value || [];
          }
          ;
        }, 100);
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    // 翻页
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    // 翻页
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // // 多选框选中数据
    handleSelectionChange: function handleSelectionChange() {
      var _this2 = this;
      var selection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var page = this.listPram.page;
      this.pageSelectIds[page] = selection.length && selection.filter(function (item) {
        return item;
      }) || [];
      console.log('pageSelectIds', this.pageSelectIds);
      this.selectIds = [];
      var pageSelects = Object.values(this.pageSelectIds || {}) || [];
      pageSelects.length && pageSelects.forEach(function (item) {
        var _this2$selectIds;
        (_this2$selectIds = _this2.selectIds).push.apply(_this2$selectIds, _toConsumableArray(item));
      });
    },
    // 商户分类；
    getCategorySelect: function getCategorySelect() {
      var _this3 = this;
      categoryApi({
        status: -1,
        type: 1
      }).then(function (res) {
        _this3.merCateList = res;
      }).catch(function (res) {
        _this3.$message.error(res.message);
      });
    }
  }
};